"use client";

import React from "react";

export function Header131() {
  return (
    /* bg-wood-light = tvoje světle šedá, text-black = černý text */
    <section id="relume" className="bg-wood-light text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="rb-12 mb-12 grid grid-cols-1 items-start gap-x-12 gap-y-5 md:mb-18 md:grid-cols-2 md:gap-y-8 lg:mb-20 lg:gap-x-20 lg:gap-y-16">
          {/* Nadpis - font Gelasio (56px) */}
          <h1 className="text-[40px] font-bold font-serif leading-[1.1] md:text-[56px]">
            Připraveni začít váš projekt?
          </h1>
          <div>
            {/* Text - 18px (text-lg) */}
            <p className="text-base md:text-lg leading-[1.6]">
              Zavolejte nám nebo napište. Prvního setkání se nebojíme.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              {/* Odkaz na TEL */}
              <a 
                href="tel:+420723856780" 
                className="px-10 py-4 bg-black text-white font-bold rounded-full hover:bg-opacity-80 transition-all inline-block text-center"
              >
                VOLAT
              </a>
              {/* Odkaz na MAIL */}
              <a 
                href="mailto:jiri@tesarstvi-sindelar.cz" 
                className="px-10 py-4 border-2 border-black text-black font-bold rounded-full hover:bg-black hover:text-white transition-all inline-block text-center"
              >
                jiri@tesarstvi-sindelar.cz
              </a>
            </div>
          </div>
        </div>
        
        {/* Jeden velký vycentrovaný obrázek - ponechán beze změny */}
        <div className="w-full overflow-hidden rounded-xl">
          <img
            src="img/Image container.png" 
            className="w-full h-auto object-cover"
            alt="Tesařství Šindelář - detail dřeva"
          />
        </div>
      </div>
    </section>
  );
}